import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styles from './Logo.module.css';
export const Logo = forwardRef(({ src, alt = 'Logo', className = '', containerClassName = '', width = 55.5, height = 42.84, variant = 'default', }, ref) => {
    const rectangleClass = variant === 'white'
        ? `${styles.decorativeRectangle} ${styles.white}`
        : styles.decorativeRectangle;
    return (_jsxs("div", { className: `${styles.logoContainer} ${containerClassName}`, children: [_jsx("div", { className: rectangleClass }), _jsx("img", { ref: ref, src: src, alt: alt, className: `${styles.logo} ${variant === 'white' ? styles.logoWhite : ''} ${className}`, width: width, height: height }), _jsx("div", { className: rectangleClass })] }));
});
Logo.displayName = 'Logo';
